import { object, array, string } from '@gogame/schemas';

import {
  COLUMN_VISIBILITY,
  COLUMN_METRIC,
  COLUMN_GENRES,
  COLUMN_APPLICATIONS,
  COLUMN_NETWORKS,
  COLUMN_PLATFORMS,
  COLUMN_COUNTRIES,
  COLUMN_MIN,
  COLUMN_AVERAGE,
  COLUMN_MAX,
  COLUMN_TOTAL,
} from 'scenes/KPI/constants';

export const columnsSchema = object({
  order: array(string()).default([
    COLUMN_VISIBILITY,
    COLUMN_METRIC,
    COLUMN_GENRES,
    COLUMN_APPLICATIONS,
    COLUMN_NETWORKS,
    COLUMN_PLATFORMS,
    COLUMN_COUNTRIES,
    COLUMN_MIN,
    COLUMN_AVERAGE,
    COLUMN_MAX,
    COLUMN_TOTAL,
  ]),
  collapsed: array(string()).default([]),
});
